// Module
var code = `<div class="grid-panel">
    {{#if !forbiddenPanel}}
        <div class="grid-panel-toolbar">
            <terceraButton name="gridEditButton"
                        terceraButtonStyle="js-button-grid-edit"
                        tooltip="panel.GridPanel.recreateButton.ToolTip"
                        SVG="true"
                        on-btnClick="editClick"
                        canCheck="true"
                        checked="{{isGridPickerOpened}}" />

            <terceraButton name="refreshButton"
                        terceraButtonStyle="js-button-refresh"
                        tooltip="panel.GridPanel.refreshAllCharts.ToolTip"
                        SVG="true"
                        on-btnClick="refreshChartClick" />
        </div>
        <div class="grid-wrapper">
            <div class="grid-panel-container" style="cursor:{{.cursor}};">
                {{#each @this.RowNumbers() as rowIdx}}
                    {{#if rowIdx > 0}}
                        <resizeSplitter name="horizontal_{{rowIdx}}" isHorizontal="true" on-splitterResize="onSplitterResize" size="3"/>
                    {{/if}}
                    <div class="grid-panel-container-row" style="height: {{standardHeight}}%;">
                        {{#each @this.ColumnNumbers() as columnIdx}}
                            {{#if columnIdx > 0}}
                                <resizeSplitter name="vertical_{{columnIdx}}" isHorizontal="false" on-splitterResize="onSplitterResize" size="3"/>
                            {{/if}}
                            <div class="grid-panel-container-row-item" style="width: {{standardWidth}}%;">
                                <chartPanel isSetFocusOnComplete="false" withOutBorder="false" showHeader="true" showFooter="false" 
                                            movable="false" resizable="false" dockablePanel="false" closeBtnVisible="false" 
                                            isRelativeStyle="true" style_addition_header="attach-detach-panel-header" 
                                            name="{{rowIdx}}_{{columnIdx}}" zIndex="null" minSizeForToolBars="300"
                                            chartSerializedSettings="{{chartSerializedSettingsDict[rowIdx + '_' + columnIdx]}}"
                                            isIgnoreLayoutProps="true"/>
                            </div>
                        {{/each}}
                    </div>
                {{/each}}
            </div>
        </div>
    {{/if}}
</div>`;
// Exports
export default code;